<div [class.bg-modal--open]="this.openMoreFiltersPopup" class="bg-modal">
    <!-- Segnalazione -->
    <div class="modal-contents" id="filtersAnnuncio">
        <div class="modal-contents__top py-2 px-4">
            <div class="fw-normal">Più filtri</div>
            <div (click)="this.closeMoreFiltersPopup()" class="close">+</div>
            <!-- <div (click)="closeSegnPopupComp()" class="close">+</div> -->
        </div>

        <div class="form pb-3">
            <div class="row">
                <div class="form-group mb-0" *ngFor="let item of this.filtersComponentObj | keyvalue">
                    <div class="d-flex align-items-center pb-1">
                        <i [ngClass]="item.value.icon"></i>
                        <p class="ms-2 mb-0 font-weight-500">{{item.value.title}}</p>
                    </div>

                    <div *ngIf="item?.value?.value?.length; else noCheckbox" class="formGroup__items d-flex">
                        <ng-container *ngFor="let value of item?.value?.value; let i = index">
                            <div class="ck-button" [class.isActive]="value.active">
                                <label class="py-0 my-0">
                                    <input (click)="this.changeFiltersSearch($event, item.key, i)" type="checkbox"
                                        value="{{value?.value}}"><span
                                        class="font-weight-400 py-0 px-2">{{value?.filterName}}</span>
                                </label>
                            </div>
                        </ng-container>
                    </div>
                    <ng-template #noCheckbox>
                        <div class="pb-2">
                            <select (change)="this.changeBathroomsValue($event, item.key)" type="checkbox"
                                class="form-control" name="bagni">
                                <option value="0" [selected]="item.value.value == 0">Indifferente</option>
                                <option value="1" [selected]="item.value.value == 1">1</option>
                                <option value="2" [selected]="item.value.value == 2">2</option>
                                <option value="3" [selected]="item.value.value == 3">3</option>
                                <option value="4" [selected]="item.value.value == 4">4</option>
                                <option value="5" [selected]="item.value.value == 5">5</option>
                                <option value="6" [selected]="item.value.value == 6">6</option>
                                <option value="7" [selected]="item.value.value == 7">7</option>
                                <option value="8" [selected]="item.value.value == 8">8</option>
                                <option value="9" [selected]="item.value.value == 9">9</option>
                                <option value="10" [selected]="item.value.value == 10">10</option>
                            </select>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-end ctaCont">
            <div (click)="cancelFilters()" class="btn colorPrimary">
                Cancella
            </div>

            <button (click)="updateSearch()" class="btn ms-2 ms-4" type="submit">
                Vedi Annunci
                <!-- <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span> -->
            </button>
        </div>

    </div>
</div>